import * as React from "react";

import Divider from "@material-ui/core/Divider";
import Dialog from "@material-ui/core/Dialog";

import MuiButton from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import ActionClose from "@material-ui/icons/Close";

import Table from "jazasoft/lib/mui/components/Table";

import { useDeepMemo } from "../../../hooks";

import { DataType, getData, getHeader } from "../feedbackHelper";

const LayDialog = props => {
  const { open, rollFields = [], lay, onClose } = props;

  const { columns, rows, title } = useDeepMemo(() => {
    let columns = [];
    let rows = [];
    let title = "";
    if (lay) {
      title = `Lay #${lay.layNo}`;
      columns = getHeader({ dataType: DataType.LAY, rollFields });
      const finalLay = {
        ...lay,
        rowList: lay?.rowList?.filter(row => row.actualLayNo === lay.layNo) || []
      };
      rows = getData({ dataType: DataType.LAY, lay: finalLay });
    }
    return { columns, rows, title };
  }, [lay, rollFields]);

  return (
    <Dialog id="dialog-container" fullWidth={true} maxWidth={lay ? "xl" : "md"} open={open} onClose={onClose}>
      <DialogTitle id="dialog-title">{title}</DialogTitle>
      <Divider />
      <DialogContent id="dialog-content" style={{ padding: 0 }}>
        <Table columns={columns} rows={rows} emptyMessage={lay && "Feedback for rolls not filled yet"} />
      </DialogContent>
      {(!rows || rows.length === 0) && <Divider />}
      <DialogActions id="dialog-actions" style={{ padding: "1em" }}>
        <MuiButton onClick={onClose} color={"primary"} variant="outlined">
          <ActionClose style={{ marginRight: 4 }} />
          Close
        </MuiButton>
      </DialogActions>
    </Dialog>
  );
};

export default LayDialog;
